import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import PlayerBar from './PlayerBar';
import ProfileReadyBanner from './ProfileReadyBanner';
import { usePlayer } from '@/context/PlayerContext';

const Layout = () => {
  const { currentTrack } = usePlayer();

  return (
    <div className="flex min-h-screen overflow-x-hidden">
      <Sidebar />
      <main className={`flex-1 ml-0 lg:ml-64 transition-all duration-300 w-full max-w-full overflow-x-hidden ${currentTrack ? 'pb-24' : ''}`}>
        <div className="p-4 md:p-8 lg:p-12 max-w-full">
          <ProfileReadyBanner />
          <Outlet />
        </div>
      </main>
      <PlayerBar />
    </div>
  );
};

export default Layout;
